<template>
  <div class="pass-rules">
    <b-collapse
      id="collapse-rules"
      :visible="show"
      class="mb-3">
      <b-card class="pl-3 pr-3 pt-1 pb-1">
        <p>
          {{ $t('RESET_PASSWORD.PASSWORD_TOO_SHORT') }}
        </p>
        <p>
          {{ $t('RESET_PASSWORD.PASSWORD_REQUIRES_NON_ALPHANUMERIC') }}
        </p>
        <p>
          {{ $t('RESET_PASSWORD.PASSWORD_REQUIRES_DIGIT') }}
        </p>
        <p>
          {{ $t('RESET_PASSWORD.PASSWORD_REQUIRES_LOWER') }}
        </p>
        <p>
          {{ $t('RESET_PASSWORD.PASSWORD_REQUIRES_UPPER') }}
        </p>
        <p>
          {{ $t('RESET_PASSWORD.PASSWORD_REQUIRES_UNIQUE_CHARS') }}
        </p>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>


<style scoped lang="scss">
.pass-rules {
  .card-body{
  padding:0;
    p{
      text-align: left;
      margin:0;
      padding:0;
      font-size: 0.6em;
    }
  }
}
</style>
